// Simple debug helper for the frontend; enable by setting VITE_DEBUG=true in your .env
export const dbg = (...args) => {
  try {
    if (import.meta.env.VITE_DEBUG === 'true') console.debug(...args);
  } catch (e) { /* ignore */ }
};

export default dbg;
